import { Link } from "react-router-dom";
import { UserSwitchOutlined } from "@ant-design/icons";
import { isAdmin, setViewAsAdmin } from "../../util/viewAsAdmin";

export const GoToAdminPage: React.FC = () => {
  if (!isAdmin()) {
    setViewAsAdmin(false);
    return null;
  }

  return (
    <Link
      to="/admin"
      className="flex items-center gap-3 mt-2 px-5 py-2 hover:bg-gray-100 cursor-pointer rounded-xl text-inherit hover:text-inherit"
    >
      <UserSwitchOutlined />
      <span className="text-center">Admin page</span>
    </Link>
  );
};
